export default __webpack_public_path__ + "images/ok_1c13e1.svg";